/** LINE reminder templates — keep in sync with billlin-agent `config/reminder_templates.py`. */

export const POLITE_TEMPLATES = [
  "สวัสดี คุณ{name} ขออนุญาตแจ้งเตือนยอดชำระ {amount} บาทที่ยังค้างอยู่ หากสะดวกแล้วรบกวนดำเนินการชำระให้เรียบร้อย และส่งสลิปกลับมาเพื่อยืนยันรายการ",
  "เรียนคุณ{name} ขอแจ้งเตือนยอดค้างชำระ {amount} บาท ขณะนี้รายการยังรอการชำระอยู่ หากชำระเรียบร้อยแล้ว รบกวนส่งหลักฐานการโอนกลับมาเพื่อให้ทีมงานตรวจสอบและปิดรายการ",
  "สวัสดี คุณ{name} ทางเราขอติดตามยอดชำระ {amount} บาทที่ยังไม่พบรายการโอนเข้า หากโอนแล้ว รบกวนส่งสลิปกลับมาอีกครั้ง หรือหากยังไม่ได้โอน รบกวนดำเนินการเมื่อสะดวก",
  "คุณ{name} ขอแจ้งว่ารายการยังมียอดค้างชำระ {amount} บาท หากสะดวกแล้วรบกวนชำระยอดดังกล่าว และส่งสลิปกลับมาเพื่อยืนยันรายการ",
  "เรียนคุณ{name} ทางเราขอแจ้งเตือนรายการชำระเงินยอด {amount} บาทที่ยังอยู่ระหว่างรอการชำระ เพื่อให้รายการดำเนินต่อได้เรียบร้อย รบกวนชำระและส่งสลิปยืนยันกลับมาเมื่อสะดวก",
  "สวัสดี คุณ{name} ขออนุญาตติดตามยอด {amount} บาท ขณะนี้ระบบยังไม่พบการชำระของรายการนี้ หากชำระแล้ว รบกวนส่งสลิปเข้ามาเพื่อให้ตรวจสอบรายการ ขอบคุณที่ช่วยดำเนินการ",
  "คุณ{name} ขอแจ้งเตือนยอดชำระ {amount} บาทที่ยังค้างอยู่ หากยังไม่ได้ดำเนินการ รบกวนชำระเมื่อสะดวก และหากชำระแล้ว รบกวนส่งหลักฐานการโอนกลับมาเพื่อยืนยันรายการ",
  "สวัสดี ขอรบกวนคุณ{name} เรื่องยอดชำระ {amount} บาท รายการนี้ยังรอการชำระอยู่ หากต้องการให้ดำเนินการต่อ รบกวนโอนยอดดังกล่าวและส่งสลิปกลับมาให้ตรวจสอบ",
  "เรียนคุณ{name} ขอแจ้งเตือนเรื่องยอดค้างชำระ {amount} บาท หากมีข้อสงสัยเกี่ยวกับยอดหรือรายการ สามารถแจ้งกลับมาได้ หากข้อมูลถูกต้องแล้ว รบกวนดำเนินการชำระให้เรียบร้อย",
  "คุณ{name} สวัสดี ขอแจ้งว่ารายการยังมียอดรอชำระ {amount} บาท รบกวนตรวจสอบยอดและดำเนินการชำระเมื่อสะดวก หลังจากโอนแล้วรบกวนส่งสลิปกลับมาเพื่อยืนยันรายการ",
] as const;

export const DIRECT_TEMPLATES = [
  "คุณ{name} ยังมียอดค้างชำระ {amount} บาท รบกวนโอนยอดนี้ให้เรียบร้อย และส่งสลิปกลับมาเพื่อยืนยันรายการ",
  "แจ้งเตือนคุณ{name}: รายการนี้ยังค้างชำระ {amount} บาท หากยังไม่ได้โอน รบกวนชำระให้เรียบร้อย แล้วส่งหลักฐานการโอนกลับมา",
  "คุณ{name} ยอด {amount} บาทยังไม่ได้รับการชำระ กรุณาตรวจสอบและโอนยอดดังกล่าวเข้ามา เมื่อโอนแล้วรบกวนส่งสลิปกลับมา",
  "คุณ{name} ขณะนี้ยังมียอดค้าง {amount} บาท รายการยังไม่สามารถปิดได้จนกว่าจะได้รับยอดชำระ รบกวนดำเนินการและส่งสลิปยืนยัน",
  "แจ้งคุณ{name} ยอดชำระ {amount} บาทยังค้างอยู่ รบกวนโอนให้ครบตามยอด และส่งหลักฐานการชำระกลับมาเพื่อให้ตรวจสอบรายการ",
  "คุณ{name} ยังไม่ได้ชำระยอด {amount} บาท รบกวนดำเนินการชำระยอดนี้ให้เรียบร้อย หากชำระแล้วกรุณาส่งสลิปกลับมาอีกครั้ง",
  "แจ้งเตือนยอดค้างชำระสำหรับคุณ{name}: จำนวน {amount} บาท กรุณาชำระยอดนี้และส่งสลิปกลับมา เพื่อให้ทีมงานดำเนินการต่อได้",
  "คุณ{name} รายการนี้ยังค้างชำระ {amount} บาท รบกวนตรวจสอบยอดและโอนเข้ามาให้เรียบร้อย หลังโอนแล้วรบกวนส่งสลิปเพื่อยืนยัน",
  "แจ้งเตือนคุณ{name}: ยังไม่พบการชำระยอด {amount} บาท หากยังไม่ได้โอน รบกวนโอนยอดดังกล่าวเข้ามา และแจ้งกลับพร้อมสลิป",
  "คุณ{name} ยอด {amount} บาทยังค้างอยู่ในรายการนี้ กรุณาชำระให้เรียบร้อยเพื่อให้ปิดรายการได้ และส่งสลิปกลับมาเมื่อโอนเสร็จ",
] as const;

/** Same stable pair LINE copy surfaces use (`COPY_*_INDEX` in reminder_templates.py). */
export const COPY_POLITE_INDEX = 2;
export const COPY_DIRECT_INDEX = 5;

export type ReminderStyle = "polite" | "direct";

export function reminderAddressee(name: string): string {
  const trimmed = name.trim();
  const prefix = "คุณ";
  return trimmed.startsWith(prefix) ? trimmed.slice(prefix.length).trim() : trimmed;
}

export function formatLineReminderAmount(amount: number): string {
  if (!Number.isFinite(amount)) return "";
  const rounded = Math.round(amount);
  if (Math.abs(amount - rounded) < 1e-9) return `${rounded}.0`;
  return String(amount);
}

export function fillReminder(
  style: ReminderStyle,
  name: string,
  amount: number,
  index?: number,
): string {
  const templates = style === "polite" ? POLITE_TEMPLATES : DIRECT_TEMPLATES;
  const chosen =
    templates[(index ?? (style === "polite" ? COPY_POLITE_INDEX : COPY_DIRECT_INDEX)) % templates.length];
  return chosen
    .replaceAll("{name}", reminderAddressee(name))
    .replaceAll("{amount}", formatLineReminderAmount(amount));
}

export function getCopyReminders(name: string, amount: number): {
  polite: string;
  direct: string;
} {
  return {
    polite: fillReminder("polite", name, amount),
    direct: fillReminder("direct", name, amount),
  };
}
